import { create } from "zustand";

/**
 * The session boundary (GRA-138): round history (historyStore) persists
 * across reloads, so "this sitting's" numbers need their own start line.
 * A session starts at module init, i.e. page load, and lasts until either
 * a reload or an explicit reset — never persisted, so a reload always opens
 * a fresh one. `startedAt` is the cutoff the session summary filters history
 * entries against (timestamp >= startedAt); `resetSession` moves the cutoff
 * to now without touching the history log itself.
 */

export interface SessionState {
  /** `Date.now()` at page load, or at the last explicit reset. */
  startedAt: number;
  /** Start a fresh session from this moment, leaving history untouched. */
  resetSession: () => void;
}

/** Build a session store; a fresh instance is its own fresh session (tests). */
export function createSessionStore() {
  return create<SessionState>((set) => ({
    startedAt: Date.now(),
    resetSession: () => set({ startedAt: Date.now() }),
  }));
}

export const useSessionStore = createSessionStore();
